<template>
  <nav v-show="showHeader && showRouter" class="nav">
    <div class="brand" @click="onBrandClick">
      <slot name="brand"></slot>
    </div>
    <div>
      <slot name="links"></slot>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Header",
  props: {
    isAuthenticated: Boolean
  },
  data: function() {
    return {
      showHeader: false
    };
  },
  mounted() {
    this.showHeader = this.$route.name !== "DigitalTwin";
  },
  computed: {
    showRouter() {
      return this.$route.name !== "DigitalTwin";
    }
  },
  methods: {
    onBrandClick() {
      this.$emit("onBrandClick");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_variables.scss";

.nav {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  height: $navbarHeight;
  background-color: #ffffff;
  border-bottom: 1px solid #f1f1f1;
  z-index: 2;
  position: fixed;
  top: 0;

  @media screen and (max-width: $MobileMaxWidth) {
    align-items: center;
    justify-content: center;
  }

  img {
    width: 154px;
    height: 58px;
    @media screen and (max-width: $MobileMaxWidth) {
      width: 77px;
      height: 29px;
    }
  }

  a {
    font-weight: bold;
    color: $secondaryFocus;
    margin-left: 15px;
    margin-right: 15px;
    padding-bottom: 8px;
    font-size: $baseTextSize;
    font-weight: 400;
    .sign-out-icon {
      color: $accentColor;
    }

    &.router-link-active {
      color: $accentColor;

      border-bottom: 2px solid $accentColor;
    }

    @media screen and (max-width: $MobileMaxWidth) {
      font-size: 14px;
    }
  }

  .brand {
    display: flex;
    align-items: center;

    @media screen and (max-width: $MobileMaxWidth) {
      align-items: center;
    }

    h1 {
      margin: 0;
      margin-left: $m1;
      color: $textColor;
      text-align: left;

      @media screen and (max-width: $MobileMaxWidth) {
        font-size: 12px;
      }
    }
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
